import {action, observable} from 'mobx';
import { getGroupList, groupAdd, groupDelete, groupRename } from '@/services/Home';
import { groupTypes } from '@/types/APITypes';
import BaseStore from '@/stores/base';
import { message } from 'antd';
import * as R from 'ramda';
import log from '@/utils/log';

class GroupStore {
  
  /* 当前展开的id */
  @observable activeGroupId: string | number;
  
  @observable isDefault: boolean = false;
  
  @observable.ref groupList: groupTypes[] = [];
  
  @action.bound async getGroupList (params: {roomId: number | string}) {
    
    const [error, result] = await getGroupList(params);
    
    if (error) return ;
  
    let index = R.findIndex(R.propEq('isDefault', 1))(result.groupList);
  
    console.log(index);
  
    this.groupList =R.concat([result.groupList[index]], R.remove(index, 1, result.groupList))
  
  
  }
  
  @action.bound async groupAdd (params: {groupName: string,roomId: number}) {
  
    if (/^[A-Za-z0-9\u4e00-\u9fa5]+$/.test(params.groupName) === false) {
      message.warning('请输入汉字字母数字');
      return
    }
  
    const length = params.groupName.replace(/[\u4e00-\u9fa5]/g,'00').length;
  
    if (length > 10 ) {
      message.warning('请输入10以为字符');
      return
    }
  
    const [error] = await groupAdd(params);
  
    if (error) {
      log({ pageId: 'P28',eventId: 'E2807', ext: ''})
      return ;
    }
    
    message.success('操作成功！')
    log({ pageId: 'P28',eventId: 'E2806', ext: ''})
  
    await this.getGroupList({roomId: BaseStore.RoomStore.activeRoom.id});
    
  }
  
  @action.bound async groupDelete (params: {}) {
    
    const [error] = await groupDelete(params);
    
    if (error) {
      log({ pageId: 'P28',eventId: 'E2802', ext: ''})
      return ;
    }
    log({ pageId: 'P28',eventId: 'E2801', ext: ''})
    message.success('操作成功！')
  
    await this.getGroupList({roomId: BaseStore.RoomStore.activeRoom.id});
    
  }
  
  @action.bound async groupRename (params: {groupName: string,roomId: number,groupId: number}) {
  
    if (!/^[A-Za-z0-9\u4e00-\u9fa5]+$/.test(params.groupName)) {
      message.warning('请输入汉字字母数字');
      return
    }
    
    const length = params.groupName.replace(/[\u4e00-\u9fa5]/g,'00').length;
    
    if (length > 10 ) {
      message.warning('请输入10以为字符');
      return
    }
    
    const [error] = await groupRename(params);
    
    if (error) {
      log({ pageId: 'P28',eventId: 'E2810', ext: ''})
      return ;
    }
    log({ pageId: 'P28',eventId: 'E2809', ext: ''})
    message.success('操作成功！')
  
    await this.getGroupList({roomId: BaseStore.RoomStore.activeRoom.id});
    
  }
  
  @action.bound setGroupId (activeGroupId: string | number) {
    
    this.activeGroupId = activeGroupId;
    if (this.groupList.length === 0) return;
    const defaultData =  R.find(R.propEq('id', activeGroupId))(this.groupList) || {}
    this.isDefault = defaultData.isDefault === 1;
    
  }
  
  
  
}

export default GroupStore;
